module.exports = __webpack_public_path__ + "static/driver1-4a6b4e79ea65f4bbc8931aa8a1ef0a02.jpg";